// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__1xOoi","col":"styles_col__2j6Nt"};